import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ServiceBase } from '../../../shared/service-base/ServiceBase';

@Injectable()
export class RelatorioOportunidadeFiltroService
  extends ServiceBase {
  private baseUrlService: string;
  url: string;

  constructor(http: HttpClient, router: Router) {
    super(http, router);

    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return this.url;
  }

  private defineURLFiltroDealers() {
    this.url = `${this.baseUrlService}/filtro/dealer`;
  }

  getFiltroDealers(): any {
    this.defineURLFiltroDealers();
    return this.get([]);
  }
}
